import { Ayah } from '@app-types/KuranTypes'
import { getSurahAnchorId } from 'helpers/surahAnchor'

export default function Basmalah({ i, ayah }: { ayah: Ayah; i: any }) {
  return (
    <div
      key={`${i}-zero`}
      id={getSurahAnchorId(ayah.surah.id)}
      className="scroll-mt-32 ayah-arabic mt-4 w-full whitespace-pre-line rounded-sm bg-slate-100 p-4 px-1 py-3 dark:bg-slate-700"
    >
      {ayah.surah.name_original} <br />﷽
    </div>
  )
}
